export default __webpack_public_path__ + "static/media/apply-leave-disabled.60c4f77f.svg";